export enum PhaseEstimatedDurations {
  enrollment = 4,
  benefitsVerification = 24,
  priorAuthorization = 96,
  fulfillment = 96,
}
